// TODO переделать на функцию из набора ACCEPTS (их пока нет)
/**
 * Очищает строку от всего, кроме цифр
 */
export const getNumbersFromStr = (value?: string): string =>
    value ? value.toString().replace(/\D+/g, '') : '';
